<template>
  <v-layout>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title>{{ getDialogTitle }}</v-card-title>
          <v-card-text class="pb-0">
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="equipo.marca"
                  label="Marca"
                  placeholder="Marca..."
                  :rules="maracaRules"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="equipo.modelo"
                  label="Modelo"
                  placeholder="Modelo..."
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="equipo.nombre"
                  label="Nombre"
                  placeholder="Nombre..."
                  :rules="nombreRules"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="d-fex justify-center py-0">
                <v-switch
                  v-model="equipo.estado"
                  inset
                  class="pt-0 mt-2"
                  color="primary"
                  label="Estado Equipo"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-textarea
                  v-model="equipo.descripcion"
                  label="Descripción"
                  placeholder="Descripción..."
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pt-0 pb-4">
            <v-btn color="primary" outlined @click="clear">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="equipos"
        :search="search"
        :loading="loader"
        loading-text="Listando Datos..."
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Listado de Equipos para Inspectores</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md6 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex
                xs12
                sm12
                md2
                class="text-center pt-3 mr-2"
                align-self-center
              >
                <v-btn color="blue" dark block @click="dialog = true">
                  Agregar Equipo
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="detalles(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    valid: true,
    equipo: {
      equipoId: null,
      marca: "",
      modelo: "",
      numeroSerier: "",
      nombre: "",
      descripcion: "",
      estado: false,
    },
    nombreRules: [
      (v) => !!v || "El Nombre es requerido",
      (v) => (v && v.length <= 50) || "Nombre debe ser menor a 50 caracteres",
    ],
    maracaRules: [
      (v) => !!v || "La Marca es requerida",
      (v) => (v && v.length <= 50) || "Marca debe ser menor a 50 caracteres",
    ],
    loader: false,
    editing: false,
    search: "",
    headers: [
      { text: "ID", value: "equipoId", align: "center", width: 100 },
      { text: "Marca", value: "marca", align: "center" },
      { text: "Modelo", value: "modelo", align: "center" },
      { text: "Número de Serie", value: "numeroSerie", align: "center" },
      { text: "Nombre", value: "nombre", align: "center" },
      { text: "Descripción", value: "descripcion", align: "center" },
      { text: "Estado", value: "estado", align: "center" },
      { text: "Editar", value: "editar", align: "center", width: 100 },
    ],
    equipos: [],
    dialog: false,
  }),
  created() {
    this.listar();
  },
  computed: {
    getDialogTitle() {
      return this.equipo.equipoId == null ? "Nuevo Equipo" : "Editar Equipo";
    },
  },
  methods: {
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Equipos", configuracion)
        .then((res) => (this.equipos = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    guardar() {
      if (this.$refs.form.validate()) {
        if (this.equipo.equipoId == null) {
          this.nuevoEquipo();
        } else {
          this.editarEquipo();
        }
      }
    },
    nuevoEquipo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/Equipos",
          {
            marca: this.equipo.marca,
            modelo: this.equipo.modelo,
            numeroSerie: this.equipo.numeroSerie,
            nombre: this.equipo.nombre,
            descripcion: this.equipo.descripcion,
            estado: this.equipo.estado,
          },
          configuracion
        )
        .then((res) => {
          this.listar();
          this.clear();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    editarEquipo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/Equipos/${this.equipo.equipoId}`,
          {
            marca: this.equipo.marca,
            modelo: this.equipo.modelo,
            numeroSerie: this.equipo.numeroSerie,
            nombre: this.equipo.nombre,
            descripcion: this.equipo.descripcion,
            estado: this.equipo.estado,
          },
          configuracion
        )
        .then(() => {
          this.listar();
          this.clear();
        })
        .catch((err) => console.error(err));
    },
    detalles(item) {
      this.dialog = true;
      this.equipo = { ...item };
    },
    clear() {
      this.dialog = false;
      this.$refs.form.resetValidation();
      this.equipo = {
        equipoId: null,
        marca: "",
        modelo: "",
        numeroSerier: "",
        nombre: "",
        descripcion: "",
        estado: false,
      };
    },
  },
};
</script>